import axios from "axios"
import { CONST_API_PERSONNEL_ACCOUNT_GET_INFO_PERSO_ENDPOINT, CONST_API_PERSONNEL_ACCOUNT_POST_SET_INFO_PERSO_ENDPOINT } from "../../../../endpoints"
import { IUserModel } from "@common-models/*"
import { ISetInfoPersoPersonnelCompteRequestModel } from "./_models"

export function getInfoPersoPersonnelAccountRequest() {
     return axios.get<IUserModel>(CONST_API_PERSONNEL_ACCOUNT_GET_INFO_PERSO_ENDPOINT)
}

export function setInfoPersoPersonnelAccountRequest(payload: ISetInfoPersoPersonnelCompteRequestModel) {
     const formData = new FormData()

     for (const [key, value] of Object.entries(payload)) {
          if (key !== "avatar") formData.append(`data[${key}]`, value)
          if (key === "avatar") formData.append(`avatar`, value)
     }

     return axios.post<IUserModel>(CONST_API_PERSONNEL_ACCOUNT_POST_SET_INFO_PERSO_ENDPOINT, formData)
}
